import { mapGetters } from 'vuex';
import { CART, CART_OPTION } from '@/stores/defs';

const cartItemPriceMixin = {
	computed: {
		...mapGetters({
			cartItem: CART.GET_CURRENT_ITEM,
			cartItemOptions: CART_OPTION.GET_ALL,
			optionsPrice: CART_OPTION.PRICE,
		}),
	},
	methods: {
		getTotal() {
			let total = 0;
			if (this.cartItem && this.cartItem.id) {
				const cartItem = this.cartItem;
				const bundle = cartItem.bundle;
				const freeChoices = cartItem.freeChoices;
				if (freeChoices || bundle) {
					return 0;
				}
				const cartOptions = this.cartItemOptions;
				const itemPrice = cartItem.getItemTotal(cartOptions);
				total = itemPrice;
			}
			return total;
		},
	},
};

export default cartItemPriceMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/cartItemPriceMixin.js